/** Complete task-scoped evidence for a selected-range edit. Offsets are UTF-16. */
export interface EditExpectation {
  selected_text: string;
  selection_start: number;
  selection_length: number;
  before_text: string;
}

const MAX_TEXT_UTF16 = 32_768;

function splitsSurrogate(text: string, offset: number): boolean {
  const left = text.charCodeAt(offset - 1);
  const right = text.charCodeAt(offset);
  return left >= 0xd800 && left <= 0xdbff && right >= 0xdc00 && right <= 0xdfff;
}

export function validEditExpectation(value: unknown): value is EditExpectation {
  if (!value || typeof value !== "object" || Array.isArray(value)) return false;
  const guard = value as Record<string, unknown>;
  if (
    Object.keys(guard).sort().join(",") !==
    "before_text,selected_text,selection_length,selection_start"
  )
    return false;
  const {
    before_text: before,
    selected_text: selected,
    selection_start: start,
    selection_length: length,
  } = guard;
  if (
    typeof before !== "string" ||
    before.length > MAX_TEXT_UTF16 ||
    typeof selected !== "string" ||
    !selected.length ||
    selected.length > MAX_TEXT_UTF16 ||
    typeof start !== "number" ||
    !Number.isSafeInteger(start) ||
    start < 0 ||
    typeof length !== "number" ||
    !Number.isSafeInteger(length) ||
    length <= 0
  )
    return false;
  const end = start + length;
  return (
    end <= before.length &&
    !splitsSurrogate(before, start) &&
    !splitsSurrogate(before, end) &&
    before.slice(start, end) === selected
  );
}
